module.exports = __webpack_public_path__ + "img/nopic.5a5ccc95.png";